import { Form } from 'antd';
import { Children, CSSProperties, PropsWithChildren, useMemo } from 'react';
import { useLabelPrintingContext } from '..';
import { LabelPrintingLayoutOrientation } from '../types';

export default function WrapperLabelPrintingPageContentPaper({
  children,
}: PropsWithChildren<unknown>) {
  const { form } = useLabelPrintingContext();
  const layout = Form.useWatch(['layout'], form);

  const layoutHeight = useMemo(() => {
    const width = layout?.width || 0;
    const height = layout?.height || 0;
    const orientation = layout?.orientation;

    const maxWidth = 800;
    const scale = Math.min(maxWidth / width, 2);

    const pageWidth = width * scale;
    const pageHeight = height * scale;
    const invertPage = orientation === LabelPrintingLayoutOrientation.landscape;

    return invertPage ? pageWidth : pageHeight;
  }, [layout]);

  const paperStyle = useMemo((): CSSProperties => {
    if (!layout) return {};

    const width = layout?.width || 0;
    const height = layout?.height || 0;
    const paddingBlock = layout?.marginBlock || 0;
    const paddingInline = layout?.marginInline || 0;
    const orientation = layout?.orientation;
    const gap = layout?.gap || 0;

    const maxWidth = 800;

    const scale = Math.min(maxWidth / width, 2);

    const fontSize = Math.max((layout?.fontSize || 8) * scale * 0.5, 8);

    const pageWidth = width * scale + 'px';
    const pageHeight = height * scale + 'px';
    const invertPage = orientation === LabelPrintingLayoutOrientation.landscape;

    const heightKey = layout.oneCardPerPage ? 'height' : 'minHeight';

    return {
      width: invertPage ? pageHeight : pageWidth,
      [heightKey]: layoutHeight + 'px',
      paddingBlock: paddingBlock * scale + 'px',
      paddingInline: paddingInline * scale + 'px',
      fontSize: fontSize + 'px',
      gap: gap * scale + 'px',
    };
  }, [layout, children, layoutHeight]);

  if (layout?.oneCardPerPage) {
    const childrens = Children.map(children, (child) => (
      <div className="print-page-content-paper" style={paperStyle}>
        {child}
      </div>
    ));

    return <>{childrens}</>;
  }

  return (
    <div className="print-page-content-paper" style={paperStyle}>
      {children}
    </div>
  );
}
